var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AfyButton } from "@affinitysystemsgroup/assurehub-ui";
import { REJECTION_CODES_TEXT } from "../../../../../constants/rejectionCodes.constants";
import { RejectionCodeFieldsRow } from "../../../../rejectionCodeFieldsRow";
import { useAddCodeRow } from "../hook/addCodeRow.hook";
import { AddCodeRowForm } from "../style/addCodeRow.style";
export var AddCodeRowView = function (props) {
    var p = useAddCodeRow(props);
    return (_jsx(AddCodeRowForm, __assign({ noValidate: true, onSubmit: p.onSubmit }, { children: _jsx(RejectionCodeFieldsRow, { control: p.control, trailing: _jsx(AfyButton, { label: REJECTION_CODES_TEXT.addCodeButton, type: "submit", variant: "filled", color: "brand", size: "sm" }) }) })));
};
